import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { currencyFormat, removeDuplicates } from '../util';

export const useQuoteTotal = () => {
  const {
    quoteSelectedValues,
    isMonthlyPlan,
  } = useSelector(({ quoting }) => quoting);
  const quoteTotal = useMemo(() => {
    const allQuotes = removeDuplicates(quoteSelectedValues, 'quoteId').reduce(
      (previous, current) => {
        if (!isMonthlyPlan) {
          return previous + current.totalAnnual;
        }

        return previous + current.totalMontly;
      },
      0,
    );

    if (!allQuotes) {
      return '0.00';
    }

    return currencyFormat({ value: allQuotes });
  }, [quoteSelectedValues, isMonthlyPlan]);

  return quoteTotal;
};
